import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import ShipsuranceIcon from './shipsurance-icon-color.svg';

import Global from '../../../store/global-selectors';
import { FormattedCurrencyContainer } from '../../../components/formatted-currency/container';

import style from './cost-review-line-item-insurance-header.module.css';

const messages = defineMessages({
  shipsuranceIcon: {
    defaultMessage: 'Shipsurance Icon',
    id: 'gJlFYh',
    description: 'Shipsurance Icon',
  },
});

export const CostReviewLineItemInsuranceHeader = ({ balance = 0.0, balanceCurrencyCode = null }) => {
  const intl = useIntl();
  const hasPersonalShipsurance = useSelector(Global.selectSellerPersonalShipsuranceAccount);
  return (
    <div className={style['cost-review-header']}>
      <div className={style['provider-logo']}>
        <img alt={intl.formatMessage(messages.shipsuranceIcon)} src={ShipsuranceIcon} />
      </div>
      <div className={style['provider-details']}>
        <div className={style['provider-name']}>Shipsurance</div>
        {!hasPersonalShipsurance && (
          <div className={style['provider-balance']}>
            <FormattedCurrencyContainer currencyCode={balanceCurrencyCode} value={balance}>
              {(formattedBalance) => (
                <FormattedMessage
                  defaultMessage='Current Balance:<s>{formattedBalance}</s>'
                  description='costReviewLineItemHeader.balance'
                  id='4xjdcK'
                  values={{
                    formattedBalance,
                    s: (chunks) => <span className={style['provider-balance-amount']}>{chunks}</span>,
                  }}
                />
              )}
            </FormattedCurrencyContainer>
          </div>
        )}
      </div>
    </div>
  );
};

CostReviewLineItemInsuranceHeader.propTypes = {
  balance: PropTypes.number,
  balanceCurrencyCode: PropTypes.string,
};
